import { render, staticRenderFns } from "./DistributorList.vue?vue&type=template&id=2dc98bd4&scoped=true"
import script from "./DistributorList.vue?vue&type=script&lang=js"
export * from "./DistributorList.vue?vue&type=script&lang=js"
import style0 from "./DistributorList.vue?vue&type=style&index=0&id=2dc98bd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc98bd4",
  null
  
)

export default component.exports